export default __webpack_public_path__ + "static/media/third-psychomotricite.f6aa07f6.jpg";